import { Box } from "@mui/material";

interface Props {
  color?: string;
  children: React.ReactNode;

  onClick: () => void;
}

const BannerWrapper = ({ children, color = "#1d70ff", onClick }: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: color,
        py: 0.5,
        px: { xs: 1, md: 2 },
        display: { xs: "auto", md: "flex" },
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        cursor: "pointer",
        "&:hover": {
          opacity: 0.5,
        },
      }}
    >
      {children}
    </Box>
  );
};
export default BannerWrapper;
